import React from "react";
import {isBoolTrue} from "../../../common/fusion-ui/utils/ReactUtils";
import {AdminFooter} from "../../components";

const AuthPageLayout = React.memo(({
                                       className = '',
                                       containerClassName = '',
                                       children,
                                       asContainer = true,
                                       asContainerFluid = true,
                                       showFooter = true,
                                       p = 0,
                                       px = '',
                                       py = '',
                                   }) => {
    return (
        <>
            <div
                className={`m-0 p-${p} px-${px} py-${py} ${className} ${isBoolTrue(asContainerFluid) ? 'container-fluid' : ''}`}
                style={{
                    width: "100vw",
                    height: "100%",
                    // minHeight: "95vh",
                    overflow: "hidden",
                }}>
                <div className={`m-0x p-0 w-100 h-100 ${containerClassName} ${isBoolTrue(asContainer) ? 'container' : ''}`}>
                    {children}
                </div>
            </div>
            {isBoolTrue(showFooter) && <AdminFooter/>}
        </>
    );
});

export default AuthPageLayout;
